import { render, staticRenderFns } from "./t-input-code-label.vue?vue&type=template&id=7f85f242&"
import script from "./t-input-code-label.vue?vue&type=script&lang=js&"
export * from "./t-input-code-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports